import React from 'react';
import logo from '../../images/logo.svg';

import { t } from '../modules/infra/i18n';

const SquireUnavailable = () => (
  <div>
    <div className="u-height-fullvh u-flex o-flexbox--column u-align-items-center u-justify-content-center">
      <img src={logo} alt="Squire Logo" />
      <div>
        <div className="c-heading u-text-center u-mt-">{t('common:squire_unavailable.title')}</div>
        <div className="c-heading u-text-center">{t('common:squire_unavailable.message')}</div>
      </div>
      <a className="c-btn c-btn--medium u-mt" href="mailto:support@getsquire.com">
        {t('common:squire_unavailable.contact_us')}
      </a>
    </div>
  </div>
  );


export default SquireUnavailable;
